var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"getAllFeedDashboard"},[_vm._m(0),_c('div',{staticClass:"getAllFeedDashboard__button"},[_c('span',{staticClass:"text",on:{"click":_vm.exportToExcel}},[_vm._v("Export")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"getAllFeedDashboard__header"},[_c('div',{staticClass:"getAllFeedDashboard__title"},[_vm._v("Get all feed")])])
}]

export { render, staticRenderFns }